import moment from "moment";

const getTime = (val) => Math.round(new Date(val).getTime() / 1000);
const format = (val, str) => moment(val).format(str);
const formatDateSlash = (val) => moment(val).format("YYYY/MM/DD");
const formatTimeSlash = (val) => moment(val).format("YYYY/MM/DD HH:mm:ss");
const formatHour = (val) => moment(val).format("HH:mm:ss");
const formatTime = (val) => moment(val).format("YYYY-MM-DD HH:mm:ss");
const formatDate = (val) => moment(val).format("YYYY-MM-DD");

const formatByType = (val, type) => moment(val).format(type);

const formatNoSecond = (val) => {
  val = val * 1000;
  return moment(val).format("YYYY/MM/DD HH:mm");
};
const formatNoYear = (val) => {
  val = val * 1000;
  return moment(val).format("MM/DD HH:mm:ss");
};
const formatWithoutYearAndSecond = (val) => {
  if (!moment(val).isValid()) return;
  val = val * 1000;
  return moment(val).format("MM/DD HH:mm");
};
const getTimeRange = (rangeType) => {
  const now = new Date();
  const curDate = now.getDate();
  const curHour = now.getHours();
  const curMinute = now.getMinutes();
  const cur = moment({ date: curDate, hour: curHour });
  const nextHour = cur.clone().add(1, "hours");
  const nextMinute = moment({ hour: curHour, minute: curMinute }).add(
    1,
    "minutes"
  );
  switch (rangeType) {
    case "fifteen_minutes":
      return {
        start: Math.round(
          new Date(nextMinute.clone().subtract(15, "minutes")).getTime() / 1000
        ),
        end: Math.round(new Date(nextMinute).getTime() / 1000),
      };
    case "one_hour":
      return {
        start: Math.round(
          new Date(nextMinute.clone().subtract(1, "hours")).getTime() / 1000
        ),
        end: Math.round(new Date(nextMinute).getTime() / 1000),
      };
    case "two_hours":
      return {
        start: Math.round(
          new Date(nextMinute.clone().subtract(2, "hours")).getTime() / 1000
        ),
        end: Math.round(new Date(nextMinute).getTime() / 1000),
      };
    case "twenty_four_hours":
      return {
        start: Math.round(
          new Date(cur.clone().subtract(1, "days")).getTime() / 1000
        ),
        end: Math.round(new Date(nextHour).getTime() / 1000),
      };
    case "today":
      return {
        start: Math.round(
          new Date(cur.clone().hour(0).minute(0).second(0)).getTime() / 1000
        ),
        end: Math.round(
          new Date(cur.clone().hour(23).minute(59).second(59)).getTime() / 1000
        ),
      };
    case "seventy_two_hours":
      return {
        start: Math.round(
          new Date(
            cur.clone().subtract(72, "hours").hour(0).minute(0).second(0)
          ).getTime() / 1000
        ),
        end: Math.round(new Date(nextHour).getTime() / 1000),
      };
    case "seven_days":
      return {
        start: Math.round(
          new Date(
            cur.clone().subtract(6, "days").hour(0).minute(0).second(0)
          ).getTime() / 1000
        ),
        end: Math.round(
          new Date(cur.clone().hour(23).minute(59).second(59)).getTime() / 1000
        ),
      };
    case "thirty_days":
      return {
        start: Math.round(
          new Date(
            cur.clone().subtract(29, "days").hour(0).minute(0).second(0)
          ).getTime() / 1000
        ),
        end: Math.round(
          new Date(cur.clone().hour(23).minute(59).second(59)).getTime() / 1000
        ),
      };
    case "ninety_days":
      return {
        start: Math.round(
          new Date(
            cur.clone().subtract(89, "days").hour(0).minute(0).second(0)
          ).getTime() / 1000
        ),
        end: Math.round(
          new Date(cur.clone().hour(23).minute(59).second(59)).getTime() / 1000
        ),
      };

    default:
      return {};
  }
};

export {
  format,
  formatDate,
  formatTime,
  formatHour,
  formatDateSlash,
  formatTimeSlash,
  formatNoYear,
  formatWithoutYearAndSecond,
  formatByType,
  getTime,
  getTimeRange,
  formatNoSecond,
};
